/**
 * Converts protocol-relative URLs (starting with //) to absolute URLs with https://
 * This is needed for Next.js Image component which doesn't support protocol-relative URLs
 */
export function fixProtocolRelativeUrl(url: string): string {
  if (!url) return url;
  
  // If the URL starts with //, prepend https:
  if (url.startsWith('//')) {
    return `https:${url}`;
  }
  
  return url;
}

/**
 * Gets the API base URL from environment variable
 * 
 * Simply returns NEXT_PUBLIC_API_URL - set this in each Vercel environment:
 * - Dev/Staging: https://94wf0srcxi.execute-api.us-east-1.amazonaws.com/stg
 * - Production: https://dcq75ovr60.execute-api.us-east-1.amazonaws.com/prod
 * 
 * Both URLs are already allowed in CSP (connect-src directive in middleware.ts and next.config.js).
 * 
 * @returns The API base URL from NEXT_PUBLIC_API_URL
 */
export function getApiBaseUrl(): string {
  return process.env.NEXT_PUBLIC_API_URL || '';
}
